import { render, staticRenderFns } from "./ModalTicketSettings.vue?vue&type=template&id=e4063052&scoped=true"
import script from "./ModalTicketSettings.vue?vue&type=script&lang=js"
export * from "./ModalTicketSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4063052",
  null
  
)

export default component.exports